import { useMemo } from 'react';
import { useUser } from './useUser';

/**
 * Détermine si l'utilisateur courant est administrateur/propriétaire
 * de l'entreprise (company) à laquelle il est rattaché.
 *
 * Règle (alignée avec le backend customer-service) :
 *  - `isCompanyOwner === true` → propriétaire/fondateur (admin par défaut)
 *  - `role` ∈ {ADMIN, admin, SUPER_ADMIN, super_admin} → admin promu
 *  - tout autre cas → user "membre" (comptable, manager, employé, etc.)
 *
 * Utilisé pour cacher les pages réservées à l'admin (création/édition entreprise,
 * gestion d'abonnements, paramètres entreprise). Les non-admins n'ont accès
 * qu'à leur profil personnel.
 */
export function useIsCompanyAdmin() {
  const { user, isLoading } = useUser();

  return useMemo(() => {
    if (isLoading || !user) {
      return { isAdmin: false, isLoading: true };
    }

    const normalizedRole = (user.role || '').toString().toUpperCase();
    const isOwner = user.isCompanyOwner === true;
    const isElevated =
      normalizedRole === 'ADMIN' || normalizedRole === 'SUPER_ADMIN';

    return {
      isAdmin: isOwner || isElevated,
      isLoading: false,
    };
  }, [user, isLoading]);
}
